// ABOUTME: Publishes react-router's navigate() to non-React call sites via navigation.ts.
// ABOUTME: Renders nothing; must be mounted once inside the BrowserRouter.

import { useEffect } from "react"
import { useNavigate } from "react-router"
import { setNavigate } from "./navigation"

export const RouterBridge = (): null => {
  const navigate = useNavigate()

  useEffect(() => {
    setNavigate(navigate)
    return () => setNavigate(null)
  }, [navigate])

  return null
}
